import { MouseEvent } from 'react'
import { Button } from 'react-bootstrap';
import { BsArrowLeftShort } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';

const BackButton = () => {
    const navigate = useNavigate();
    const handleClick = (event: MouseEvent) => {
        event.stopPropagation();
        navigate(-1);
    }

    return (
        <Button variant="link" onClick={handleClick}><BsArrowLeftShort size="1.5em"/>Back</Button>
    )
}

export default BackButton